import { BehaviorSubject } from 'rxjs';
import { ProdutoService } from 'app/shared/services/produto.service';
import { ChangeDetectionStrategy, HostListener, Component, Inject, OnDestroy, OnInit, ChangeDetectorRef, ViewChild, ViewContainerRef } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { Produto } from 'app/shared/interfaces/produto';
import { AppConfirmService } from 'app/shared/services/app-confirm/app-confirm.service';
import { LayoutService } from 'app/shared/services/layout.service';
import { ActivatedRoute, Router } from '@angular/router';


@Component({
  selector: 'app-produto-images-popup',
  templateUrl: './produto-images-popup.component.html',
  styleUrls: ['./produto-images-popup.component.scss']
})
export class ProdutoImagesPopupComponent implements OnInit {


  public produtoForm: FormGroup;
  produto: Produto;
  layoutConf: any;
  file: any;
  showImages = true;
  imagens$: BehaviorSubject<number[]> = new BehaviorSubject<number[]>([]);
  @ViewChild('imagesContainer', {read: ViewContainerRef}) imagesContainer: ViewContainerRef;


  /**
   * Ao Teclar Esc
   */
  @HostListener('window:keyup.esc') onKeyUp() {
    if (this.dialog.openDialogs.length > 0) {
      console.log('@HostListener(window:keyup.esc) onKeyUp()');
      this.confirmService.confirm({ message: `Deseja realmente fechar? Poderá haver perda de dados.` })
        .subscribe(res => {
          if (res) {
            this.dialogRef.close();
          }
        });
    }
  }


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ProdutoImagesPopupComponent>,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private confirmService: AppConfirmService,
    private layout: LayoutService,
    private produtoService: ProdutoService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.layoutConf = this.layout.layoutConf;
    this.produto = this.data.payload;
    console.log(`Produto: ${this.produto.codigo} - ${this.produto.descricao}`);
    this.imagens$.next([].constructor(this.produto.totalImages > 5 ? 5 : this.produto.totalImages));
    console.log(`images$ ${JSON.stringify(this.imagens$)}`);
    console.log(`produto\n ${JSON.stringify(this.produto)}`);
    
    this.buildProdutoForm(this.produto);

  }

  buildProdutoForm(produto: Produto) {
    this.produtoForm = this.fb.group({
      file: [''],
    })

  }


  saveImage() {
    console.log(`Salvando ${JSON.stringify(this.file)}`)
    
    if (this.file) {
      const message = 'Salvar Imagem?';
      this.confirmService.confirm({ message: message })
        .subscribe(res => {
          if (res) {
            const form = new FormData();
            
            form.append('file', this.file);

            console.log(`formaData ${JSON.stringify(form)}`);
            this.produtoService.uploadImage(form, this.produto.id).subscribe(() => {
              this.file = null;
              this.setShowImages(true);
            });
          }
        });
    } else {
      this.confirmService.confirm({
        title: 'A T E N Ç Ã O !', message:
          'Selecione uma imagem!', error: true
      })
      return;
    }
  }

  setShowImages(addIndex: boolean) {
    console.log('RELOAD IMAGES');
    const oldIndex = this.imagens$.value.length;
    setTimeout(() => {
      this.imagens$.next([]);
    }, 1);
    setTimeout(() => {
      this.imagens$.next([].constructor(oldIndex >= 5 ? 5 : oldIndex +  (addIndex ? +1 : -1 )));
    }, 1);

    // this.changeUrl();
    // this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    // this.router.onSameUrlNavigation = 'reload';
    // this.router.navigate([this.changeLocationUrl ]);
  }

  getImage(produtoId: number, index: number) {
    return this.produtoService.getImage(produtoId, index);
  }

  getImageUrl(produtoId: number, index: number) {
    console.log(`arametro para imagem: ${produtoId} index: ${index}`);
    
    return this.produtoService.getImageUrl(produtoId, index);
  }

  deleteImage(index: number) {
    this.confirmService.confirm({ message: 'Deseja realmente deletar a Imagem?' })
      .subscribe(res => {
        if (res) {
          this.produtoService.deleteImage(this.produto.id, index).subscribe(() => {
            // this.router.navigateByUrl('/produto_detail/' + this.produto.id + '/5');
            // this.confirmService.confirm({
            //   title: 'SUCESSO!', message:
            //   'Imagem deletada!', error: false
            // });
            this.setShowImages(false);
          });
        }
      });
  }


  validateAllFormFields(formGroup: FormGroup) {         // {1}
    Object.keys(formGroup.controls).forEach(field => {  // {2}
      const control = formGroup.get(field);             // {3}
      if (control instanceof FormControl) {             // {4}
        console.log(field + ' - ' + control.valid);
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {        // {5}
        this.validateAllFormFields(control);            // {6}
      }
    });
  }

 
  

  close() {
    this.dialogRef.close();
  }

}
